import React, { useState } from "react";
import styles from "./CaseStudy.module.css";
import { Link } from "react-router-dom";
import fakeData from "./fakeData";

const CaseStudy = () => {
  const [data, setData] = useState(fakeData);
  const [active, setActive] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const filterData = (category) => {
    const filtered = fakeData.filter((x) => x.category === category);
    setData(filtered);
  };

  const activeNav = (index) => {
    const temp = Array(9).fill(false);
    temp[index] = true;
    setActive(temp);
  };

  return (
    <div className={`container ${styles.contain} overflow-hidden`}>
      <p className={styles.head}>WHAT WE DO</p>

      {/* <div>
        <p className={styles.our}>OUR CASE&nbsp;</p>
        <p className={styles.study}>STUDIES</p>
      </div> */}

      {/* Navigation */}
      <div className={styles.grp_btn}>
        <div className="d-flex justify-content-center flex-wrap">
          <p
            onClick={() => {
              setData(fakeData);
              activeNav(0);
            }}
            className={`${styles.filter} ${active[0] ? styles.active : ""}`}
          >
            ALL
          </p>

          <p
            onClick={() => {
              filterData("technology");
              activeNav(1);
            }}
            className={`${styles.filter} ${active[1] ? styles.active : ""}`}
          >
            TECHNOLOGY
          </p>

          <p
            onClick={() => {
              filterData("ai");
              activeNav(2);
            }}
            className={`${styles.filter} ${active[2] ? styles.active : ""}`}
          >
            SNEW AI
          </p>

          <p
            onClick={() => {
              filterData("events");
              activeNav(3);
            }}
            className={`${styles.filter} ${active[3] ? styles.active : ""}`}
          >
            EVENTS
          </p>

          <p
            onClick={() => {
              filterData("media");
              activeNav(4);
            }}
            className={`${styles.filter} ${active[4] ? styles.active : ""}`}
          >
            MEDIA
          </p>

          <p
            onClick={() => {
              filterData("logistics");
              activeNav(5);
            }}
            className={`${styles.filter} ${active[5] ? styles.active : ""}`}
          >
            LOGISTICS
          </p>
        </div>

        <div className="d-flex justify-content-center flex-wrap mt-3">
          <p
            onClick={() => {
              filterData("food");
              activeNav(6);
            }}
            className={`${styles.filter} ${active[6] ? styles.active : ""}`}
          >
            CONSUMABLES
          </p>

          <p
            onClick={() => {
              filterData("electronics");
              activeNav(7);
            }}
            className={`${styles.filter} ${active[7] ? styles.active : ""}`}
          >
            ELECTRONICS
          </p>

          <p
            onClick={() => {
              filterData("space");
              activeNav(8);
            }}
            className={`${styles.filter} ${active[8] ? styles.active : ""}`}
          >
            SNEW SPACE
          </p>
        </div>
      </div>

      {/* Cards */}
      <div className="row mb-2">
        {data.map((x) => (
          <div key={x.id} className="col-md-4 col-sm-6 mt-4">
            <Link style={{ textDecoration: "none" }}>
              <div
                className={styles.img}
                style={{
                  backgroundImage: `linear-gradient(rgba(255,255,255,0), rgba(5,25,81,.55)), url(${x.img})`,
                }}
              >
                <p className={styles.imgText1}>{x.designation}</p>
                <p className={styles.imgText2}>{x.title}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseStudy;
